import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import BaseMarcomContext from './BaseMarcomContext.esm.js';

var BaseMarcomComponent = function (_a) {
    var source = _a.source, props = __rest(_a, ["source"]);
    return (React.createElement(BaseMarcomContext, null,
        React.createElement(BaseNucleobaseComponent, __assign({ source: source }, props))));
};

export { BaseMarcomComponent as default };
//# sourceMappingURL=BaseMarcomComponent.esm.js.map
